import {
  AttachMoney as AttachMoneyIcon,
  Storage as StorageIcon,
  RssFeed as RssFeedIcon,
  AccountTree as AccountTreeIcon,
} from '@mui/icons-material';
import { SidebarItem } from './Sidebar';

export const defaultSidebarItems: SidebarItem[] = [
  {
    path: '/otc',
    label: 'OTC Manager',
    icon: <AttachMoneyIcon color="primary" />,
  },
  {
    path: '/data-feed-new',
    label: 'Data Feed',
    icon: <RssFeedIcon color="primary" />,
  },
  {
    path: '/database',
    label: 'Database',
    icon: <StorageIcon color="primary" />,
  },
  {
    path: '/flows-automations',
    label: 'Flows & Automations',
    icon: <AccountTreeIcon color="primary" />,
  },
];
